import { useMutation } from "@apollo/client/react";import { Grid } from '@mui/material';
import React, { useMemo, useState, useEffect } from 'react';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import Chip from '@mui/material/Chip';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';

import './insumoValidatePreviewContent.scss';
import { useLocation } from 'react-router-dom';
import { TextField } from '@mui/material';

import { useNavigate } from 'react-router-dom';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import { CHANGE_STATE_VALIDAR_INSUMO } from '../../../data/graphQL/mutations/Insumos/changeStatusValidarInsumo';
import toast from 'react-hot-toast';

export const InsumoValidatePreviewContent = ({ setChildrenAction }) => {
  const location = useLocation();
  const stateData = location.state;
  const editFullFormData = stateData?.Insumo;
  const allowedWriteParam = stateData?.AllowedWrite;
  const navigate = useNavigate();

  const [allowedWrite, setAllowedWrite] = useState(allowedWriteParam);
  const [rechazarLoading, setRechazarLoading] = useState(false);

  useEffect(() => {
    if (allowedWrite) {
      setChildrenAction(() =>
      <div className='buttons-preview-actions'>
                    <div className='button-rechazar'>
                        <CustomButton
            variant='outlined'
            onClick={handleClickOpen}>
            
                            Rechazar
                        </CustomButton>
                    </div>
                    <CustomButton
          isLoading={changeStateLoading}
          onClick={handleClickAprobar}>
          
                        Validar
                    </CustomButton>
                </div>);
    }
  }, []);

  //Actions
  const handleClickAprobar = () => {
    changeStateValidacion({
      variables: {
        input: {
          idInsumo: editFullFormData.idInsumoN,
          validado: true
        }
      }
    });
  };

  const handleClickRechazar = () => {
    if (motivoRechazo != "" && motivoRechazo != null) {
      setRechazarLoading(true);
      changeStateValidacion({
        variables: {
          input: {
            idInsumo: editFullFormData.idInsumoN,
            validado: false,
            motivoRechazo: motivoRechazo
          }
        }
      });
    } else {
      toast.error("El motivo de rechazo es obligatorio");
    }
  };

  const [changeStateValidacion, { loading: changeStateLoading }] = useMutation(CHANGE_STATE_VALIDAR_INSUMO, {
    onCompleted: (data) => {
      setRechazarLoading(false);
      navigate('/validarInsumo');
    }
  });

  const [open, setOpen] = useState(false);
  const [motivoRechazo, setMotivoRechazo] = useState('');

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const initialColumnsClientes = [
  {
    field: 'idInsumo',
    headerName: 'Código',
    flex: 0.05
  },
  {
    field: 'descripcion',
    headerName: 'Descripción',
    headerAlign: 'left',
    align: 'left'
  }];

  const columnsClientes = useMemo(() => generateColumnsDefaultConfiguration(initialColumnsClientes), []);

  const initialColumnsProgramas = [
  {
    field: 'descripcion',
    headerName: 'Descripción',
    headerAlign: 'left',
    align: 'left'
  }];

  const columnsProgramas = useMemo(() => generateColumnsDefaultConfiguration(initialColumnsProgramas), []);

  const initialColumnsInsumoCaja = [
  {
    field: 'idInsumo',
    headerName: 'Código',
    flex: 0.05
  },
  {
    field: 'descripcion',
    headerName: 'Descripción',
    headerAlign: 'left',
    align: 'left'
  },
  {
    field: 'cantidad',
    headerName: 'Cantidad',
    headerAlign: 'left',
    align: 'left'
  }];

  const columnsInsumoCaja = useMemo(() => generateColumnsDefaultConfiguration(initialColumnsInsumoCaja), []);

  const initialColumnsInsumoTM = [
  {
    field: 'idInsumo',
    headerName: 'Código',
    flex: 0.05
  },
  {
    field: 'descripcion',
    headerName: 'Descripción',
    headerAlign: 'left',
    align: 'left'
  }];

  const columnsInsumoTM = useMemo(() => generateColumnsDefaultConfiguration(initialColumnsInsumoTM), []);

  return <>
        {/* Datos Generales */}
        <div className='card-container'>
            <div className='titulo-seccion'> Datos generales</div>
            <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2,
          md: 8
        }}
        rowGap={2}>
        
                <Grid size={{ md: 3 }}>
                    <strong>Origen</strong>
                    <br></br>
                    <label>{editFullFormData.esSap ? "SAP" : "NSAP"}</label>
                </Grid>
                <Grid size={{ md: 2 }}>
                    <strong>Insumo</strong>
                    <br></br>
                    <label>{editFullFormData.idInsumo}</label>
                </Grid>
                <Grid size={{ md: 2 }}>
                    <strong>Franja etarea</strong>
                    <br></br>
                    <label>{editFullFormData.franjaEtarea}</label>
                </Grid>
                <Grid size={{ md: 1 }}>
                    <strong>Activo</strong>
                    <br></br>
                    <Chip className='chip-preview' label={editFullFormData.activo ? 'SI' : 'NO'} />
                </Grid>

                <Grid size={{ md: 8 }}>
                    <strong>Validado</strong>
                    <br></br>
                    <Chip className='chip-preview' label={editFullFormData.validado ? 'SI' : 'NO'} />
                </Grid>

                <Grid size={{ md: 3 }}>
                    <strong>Fabricante</strong>
                    <br></br>
                    <label>{editFullFormData.fabricante}</label>
                </Grid>
                <Grid size={{ md: 2 }}>
                    <strong>Tipo de insumo</strong>
                    <br></br>
                    <label>{editFullFormData.tipoInsumo}</label>
                </Grid>
                <Grid size={{ md: 3 }}>
                    <strong>Cantidad de días</strong>
                    <br></br>
                    <label>{editFullFormData.cantidadDias}</label>
                </Grid>
                
                <Grid size={{ md: 8 }}>
                    <strong>Descripción</strong>
                    <br></br>
                    <label>{editFullFormData.descripcion}</label>
                </Grid>
                <Grid size={{ md: 4 }}>
                    <strong>Descripción genérica</strong>
                    <br></br>
                    <label>{editFullFormData.descripcionGenerica}</label>
                </Grid>
                <Grid size={{ md: 4 }}>
                    <strong>Presentación genérica</strong>
                    <br></br>
                    <label>{editFullFormData.presentacionGenerica}</label>
                </Grid>

                <Grid size={{ md: 2 }}>
                    <strong>Presentación comercial</strong>
                    <br></br>
                    <label>{editFullFormData.presentacion}</label>
                </Grid>
                <Grid size={{ md: 2 }}>
                    <strong>Unidad</strong>
                    <br></br>
                    <label>{editFullFormData.unidad}</label>
                </Grid>
                <Grid size={{ md: 2 }}>
                    <strong>Cantidad por caja</strong>
                    <br></br>
                    <label>{editFullFormData.cantxPack}</label>
                </Grid>
                <Grid size={{ md: 1 }}>
                    <strong>Peso unitario</strong>
                    <br></br>
                    <label>{editFullFormData.pesoUnitario}</label>
                </Grid>
                <Grid size={{ md: 1 }}>
                    <strong>Fraccionable</strong>
                    <br></br>
                    <Chip className='chip-preview' label={editFullFormData.fraccionable ? 'SI' : 'NO'} />
                </Grid>
                <Grid size={{ md: 1 }}>
                    <strong>Calorías</strong>
                    <br></br>
                    <label>{editFullFormData.calorias}</label>
                </Grid>
                <Grid size={{ md: 1 }}>
                    <strong>Proteínas</strong>
                    <br></br>
                    <label>{editFullFormData.proteinas}</label>
                </Grid>
                <Grid size={{ md: 4 }}></Grid>
                {
        editFullFormData.motivoValidacion != "" && editFullFormData.motivoValidacion != null &&
        <Grid size={{ md: 8 }}>
                        <strong>Motivo de rechazo</strong>
                        <br></br>
                        <label>{editFullFormData.motivoValidacion}</label>
                    </Grid>
        }
                
            </Grid>
        </div>        
        {/* compatibilidades */}
        <div className='card-container'>
            <div className='titulo-seccion'>Contraindicaciones / Compatibilidades</div>
            <strong>Alergias</strong>
                {
      editFullFormData?.alergias.length === 0 &&
      <div className='card-sin-ingresos'>
                        <label> No hay ninguna alergia ingresada </label>
                    </div>
      }
                {
      editFullFormData?.alergias.length != 0 &&
      <div className='chips-container'>    
                    {
        editFullFormData?.alergias?.map((value, index) => {
          if (value !== '') {
            return (
              <Chip className='chip-preview' key={value.descripcion + index} label={value.descripcion} />);

          }})
        }   
                    </div>
      }
            
            <strong>Compatibilidades</strong>
            {
      editFullFormData?.compatibilidades.length === 0 &&
      <div className='card-sin-ingresos'>
                    <label> No hay ningún insumo compatible ingresado </label>
                </div>
      }
            {
      editFullFormData?.compatibilidades.length != 0 &&
      <div className='clientes-grilla'>
                    <DataGridGenerico
          hideFooterPagination={true}
          toolbar={false}
          columns={columnsClientes}
          rows={editFullFormData?.compatibilidades} />
        
                </div>
      }
        </div>
        {/* programas */}
        <div className='card-container'>
            <div className='titulo-seccion'>Programas</div>            
            {
      editFullFormData?.programas.length === 0 &&
      <div className='card-sin-ingresos'>
                    <label> No hay ningún programa ingresado </label>
                </div>
      }
            {
      editFullFormData?.programas.length != 0 &&
      <div className='clientes-grilla'>
                    <DataGridGenerico
          hideFooterPagination={true}
          toolbar={false}
          columns={columnsProgramas}
          rows={editFullFormData?.programas} />
        
                </div>
      }
        </div>
        {/* categorización */}
        {
    // nutrición
    editFullFormData?.idTipoInsumo == 1 &&
    <div className='card-container'>
                <div className='titulo-seccion'>Categorización</div>    
                <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2,
          md: 8
        }}
        rowGap={2}>
        
                <Grid size={{ md: 8 }}>
                    <strong>Nutrición</strong>    
                    <br />                
                    <label>{parseInt(editFullFormData.eleccion, 10) > 0 ? editFullFormData.eleccion + "ta" : "NO"}</label>
                    </Grid>       
                </Grid>
            </div>
    }
        {
    // caja
    editFullFormData?.idTipoInsumo == 2 &&
    <div className='card-container'>
                <div className='titulo-seccion'>Categorización</div>
                <strong>Caja</strong>  
                {/* tipo acceso */}
                Tipo de Acceso
                {
      editFullFormData?.insumoTipoAccesos.length != 0 &&
      <div className='chips-container'>    
                    {
        editFullFormData?.insumoTipoAccesos?.map((value, index) => {
          if (value !== '') {
            return (
              <Chip className='chip-preview' key={value.nombre + index} label={value.nombre} />);

          }})
        }   
                    </div>
      }
                {/* productos TM */}
                Productos TM
                {
      editFullFormData?.insumoTM.length === 0 &&
      <div className='card-sin-ingresos'>
                        <label> No hay ningún producto TM ingresado </label>
                    </div>
      }
                {
      editFullFormData?.insumoTM.length != 0 &&
      <div className='clientes-grilla'>
                        <DataGridGenerico
          hideFooterPagination={true}
          toolbar={false}
          columns={columnsInsumoTM}
          rows={editFullFormData?.insumoTM} />
        
                    </div>
      }

                Productos      
                {/* productos */}
                {
      editFullFormData?.insumoCajas.length === 0 &&
      <div className='card-sin-ingresos'>
                        <label> No hay ningún producto ingresado </label>
                    </div>
      }
                {
      editFullFormData?.insumoCajas.length != 0 &&
      <div className='clientes-grilla'>
                        <DataGridGenerico
          hideFooterPagination={true}
          toolbar={false}
          columns={columnsInsumoCaja}
          rows={editFullFormData?.insumoCajas} />
        
                    </div>
      }
            </div>
    }


        <CustomDialog
      open={open}
      onClose={handleClose}
      title='Rechazo'
      onCancel={handleClose}
      onAccept={handleClickRechazar}
      acceptLoading={rechazarLoading}
      acceptText='Rechazar'
      fullWidth={true}>
      
            <>
                <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Motivo"
          type="text"
          fullWidth
          variant="standard"
          value={motivoRechazo}
          onChange={(e) => setMotivoRechazo(e.target.value)} />
        
            </>            
        </CustomDialog>
    </>;
};